import { useEffect,useState } from "react";
import { Item } from "../core/item";
import {
  createAzureStorageClient,
} from "../services/azureBlobService";
import { useContainer } from "./useContainer";
import { useNotifications } from "../ui";

export const useAppItems = () => {
  const { url, client } = useContainer();
  const [items, setItems] = useState<Item[]>();
  const { show } = useNotifications();

  useEffect(() => {
    if (!url) return;
    fetchItems();
  }, [url]);

  const fetchItems = async () => {
    if (!client) {
      setItems([]);
      console.log("No storage client available to fetch items.");
      return;
    } else {
      const items = await client.listItems();
      const sortItemsByDate = (a: Item, b: Item) =>
        Number(b.createdOn) - Number(a.createdOn);
      setItems(items.sort(sortItemsByDate));
      console.log("Fetched items:", items.length);
    }
  };

  const removeItem = (name: string) => {
    if (!client) return;
    client
      .removeItem(name)
      .then(() => fetchItems())
      .catch((e: any) => {
        show(
            "Error while deleting file: " + e.message,
            "error"
          );
      });
  };

  return {
    items,
    fetchItems,
    removeItem,
  };
};
